import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CookiesService } from '../../../../core/services/cookies.service';
import { LanguageService } from '../../../../core/services/language.service';
import { ButtonComponent } from '../../buttons/button/button.component';
import { SiteLogoComponent } from '../../site-logo/site-logo.component';

@Component({
  selector: 'app-accept-cookies',
  templateUrl: './accept-cookies.component.html',
  imports: [SiteLogoComponent, ButtonComponent, RouterLink],
})
export class AcceptCookiesComponent {
  cookiesService = inject(CookiesService);
  languageService = inject(LanguageService);
}
